import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { mdiDeleteForever } from '@mdi/js';
import Icon from '@mdi/react';
import instance from '../../../api/api';
import { IRequest } from './story-recieved-requests.component';
import config from '../../../config/config';
import Notification, { notificationImages } from "../../../components/notifications/notification.component"
import ConfirmModal from '../../_helper/confirm-modal.component';
import { useTranslation } from "react-i18next";
import { NotificationType } from '../../../interfaces/notification';

interface IProps {
    show: boolean
    onHide: () => void
    updateList: Function
    request: IRequest
}

export default function StoryRequestActionModal(props:IProps){

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const { t } = useTranslation();
 
    // hard-copy
    const StoryRequestNotifications = {
        hidden: "",
        default: { icon: notificationImages.crying, title: "", text: "", success: NotificationType.problem },
        requestDeclined: { icon: notificationImages.happiness, title: t("Success"), text: t("The request has been declined"), success: NotificationType.success },
        requestDeleted: { icon: notificationImages.happiness, title: t("Success"), text: t("The request has been deleted"), success: NotificationType.success },
        requestFailedToDelete: { icon: notificationImages.crying, title: t("Warning"), text: t("Failed to delete request"), success: NotificationType.problem },
        teamInformed: { icon: notificationImages.happiness, title: t("Success"), text: t("Your team has been informed"), success: NotificationType.success },
        missingYearError: { icon: notificationImages.crying, title: t("Warning"), text: t("The year of the story is a required field"), success: NotificationType.problem },
    }

    const [ showNotification, setShowNotification] = useState<any>(StoryRequestNotifications.hidden);    

    async function declineRequest() {
        try {
            await instance.delete('/requests/' + props.request._id);

            setShowConfirmModal(false);            
            setShowNotification(StoryRequestNotifications.requestDeleted);

            setTimeout(() => {              
                setShowNotification(StoryRequestNotifications.hidden);
                props.onHide();
                props.updateList(true);          
            }, config.modalCloseTimeout);
        }
        catch(err) {
            setShowNotification(StoryRequestNotifications.requestFailedToDelete);            
            console.log('Error', err)
        }        

    }

    return(
        <Modal className="story-action-modal" show={props.show} onHide={props.onHide}>
            <Modal.Header className="" closeButton>
            </Modal.Header>
            <Modal.Body className="edit-card-content">
                <div className="link-row" onClick={() => setShowConfirmModal(true)}>
                    <Icon size={1} path={ mdiDeleteForever } /><p className="main-text-info">{t("Delete Request")}</p>
                    <p className="info-text">{t("Your request is cancelled")}</p>
                </div>
                {showNotification ? <Notification data={showNotification} close={() => setShowNotification(StoryRequestNotifications.hidden)} /> : null}                
            </Modal.Body>
            <ConfirmModal
                show={showConfirmModal}
                handleClose={() => setShowConfirmModal(false)}
                modalTitle="Unsaved Information"
                modalBody={() => (
                    <div>
                        <p>{t("This story request will be deleted from everyone")}</p>
                    </div>
                )}
                reject={() => {
                    props.onHide();
                    setShowConfirmModal(false);
                }}
                confirm={declineRequest}
            />            
        </Modal>
    );
}